export default __webpack_public_path__ + "images/einstein-left.png";